<template>
  <v-app id="home">
    <v-main class="background-home">
      <view-container>
        <v-container>
          <v-row justify="end">
            <v-col cols="12" md="12">
              <h2
                style="color: #005591"
                v-text="'Establece tu nueva contraseña'"
                class="text-center"
              />
            </v-col>
          </v-row>
        </v-container>
        <auto-container>
          <v-container>
            <v-row class="mb-6 text-center" justify="center">
              <v-col cols="12" md="12" class="padding-b0 padding-t10">
                <BasicInput
                  min8
                  alfaNumeric
                  number
                  password
                  v-model="password"
                  :placeholder="
                    $route.name == 'changePassword'
                      ? 'Contraseña actual'
                      : 'Password'
                  "
                />
              </v-col>
              <v-col cols="12" md="12" class="padding-b0 padding-t0">
                <BasicInput
                  v-model="password2"
                  min8
                  alfaNumeric
                  number
                  password
                  :placeholder="
                    $route.name == 'changePassword'
                      ? 'Nueva contraseña'
                      : 'Confirmar password'
                  "
                />
              </v-col>
              <v-col cols="12" md="12" class="padding-b0 padding-t0">
                <basic-btn
                  v-if="$route.name == 'changePassword'"
                  block
                  text="Cambiar"
                  @click="changePassword"
                />
                <basic-btn
                  v-if="$route.name == 'newPassword'"
                  block
                  text="Guardar"
                  @click="reset"
                />
              </v-col>
            </v-row>
          </v-container>
        </auto-container>
      </view-container>
    </v-main>
  </v-app>
</template>

<script>
import {
  AutoContainer,
  ViewContainer,
  BasicInput,
  BasicBtn,
} from "@/components";
import { services, alertMsg } from "@/utils";

export default {
  name: "home",
  components: { AutoContainer, ViewContainer, BasicInput, BasicBtn },
  data: () => ({
    password: "",
    password2: "",
    code: "",
    rules: {},
    dialogs: {},
    links: {},
  }),
  mounted() {
    this.code = this.$route.query.id;
  },
  methods: {
    reset() {
      let data = {
        data: {
          codigo: this.code,
          password: this.password,
        },
      };
      setTimeout(() => {
        this.axios
          .post(services.routes.resetPassword, data)
          .then((response) => {
            this.$router.push("/");
          })
          .catch((error) => {})
          .finally(() => {});
      }, 300);
    },
    changePassword() {
      let data = {
        data: {
          oldPassword: this.password,
          newPassword: this.password2,
        },
      };

      services
        .ws("post", "changePassword", data)
        .then((res) => {
          if (res.ok) {
            alertMsg.alert(
              "Tu contraseña ha sido modificada exitosamente",
              "success"
            );
            setTimeout(() => {
              this.$router.push("/client/User");
            }, 5000);
          } else {
            alertMsg.alert(
              "La contraseña no cumple con los requisitos de seguridad o la contraseña anterior no es válida",
              "error"
            );
          }
        })
        .catch((error) => {
          alertMsg.alert(
            "La contraseña no cumple con los requisitos de seguridad o la contraseña anterior no es válida",
            "error"
          );
        })
        .finally(() => {});
    },
  },
};
</script>

<style scoped>
.padding-b0 {
  padding-bottom: 0px;
}
.padding-t0 {
  padding-top: 0px;
}
.padding-t10 {
  padding-top: 10%;
}
.alignText {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
